import { useWindowSize } from '@passkeys/hooks';

const COLLAPSED_THRESHOLD = 300;

const useIsCollapsed = () => {
  const { width } = useWindowSize();

  return (
    !__STANDALONE_MODE__ && // Wallet is never collapsed in standalone mode.
    width <= COLLAPSED_THRESHOLD
  );
};

export default useIsCollapsed;
